import { render, staticRenderFns } from "./GuestUpdatePassword.vue?vue&type=template&id=2349bcc4"
import script from "./GuestUpdatePassword.vue?vue&type=script&lang=js"
export * from "./GuestUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports